import * as Pet from 'src/replicant/pet';
import { PetModel } from './PetModel';
import StateObserver from 'src/StateObserver';
import features from 'src/replicant/ruleset/features';
import { getSelectedDecorationsState } from 'src/replicant/decoration/decoration.getters';
import * as Fate from '../../replicant/fate';

export class PlayerPetModel implements PetModel {
  public state() {
    const { user } = StateObserver.getState();
    const now = StateObserver.now();
    return Fate.getters.getVisiblePetState(user, now);
  }

  public species() {
    const { user } = StateObserver.getState();
    return Pet.getters.getEquippedPetSpecies(user);
  }

  public stage() {
    return this.currentEvolution?.stage;
  }

  private get currentEvolution() {
    const { user } = StateObserver.getState();
    return Pet.getters.getCurrentEvolution(user);
  }

  public features() {
    const { user } = StateObserver.getState();
    return features(user);
  }

  public decorations() {
    const { user } = StateObserver.getState();
    return getSelectedDecorationsState(user);
  }
}
